import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"
import styled from "styled-components"
import {Input} from "@irati/ui/src/FormItem"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"
import {twoDecimalPlacesOptional} from "@irati/utils/validation/regex/number"

const StyledInput = styled(Input)`
  text-align: left;
`

const PROPERTY = "savings.userSavings.value"

const VALIDATION_MESSAGE = "admin.components.card.savingsValue.validationMessage"

export const schema = (required) => Validation
  .string(required ? "admin.components.card.savingsValue.schema.validation.string" : null)
  .test("admin.components.card.savingsValue.schema.test.optional", VALIDATION_MESSAGE, twoDecimalPlacesOptional)
  .test("admin.components.card.savingsValue.schema.test.range", VALIDATION_MESSAGE, (value) => {
    if (!value) return true
    return value < 10000 && value > 0
  })


const SavingsValue = ({benefit, onChange, required, ...props}) => {
  return (
    <StyledInput
      name={PROPERTY}
      value={get(benefit, `${PROPERTY}`, null)}
      onChange={(value) => onChange(PROPERTY, value)}
      validation={schema(required)}
      {...props}
      id={id(PROPERTY, props)} />
  )
}

SavingsValue.propTypes = {
  benefit: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  placeholder: PropTypes.string,
  label: PropTypes.string
}

SavingsValue.defaultProps = {
  required: false,
  placeholder: "admin.components.card.savingsValue.placeholder",
  label: "admin.components.card.savingsValue.label",
  id: "benefit"
}

export default SavingsValue
